import React from 'react';

interface RefractionProps {
  data: {
    sphere_od: string;
    sphere_oi: string;
    cylinder_od: string;
    cylinder_oi: string;
    axis_od: string;
    axis_oi: string;
    add_od: string;
    add_oi: string;
  };
  onChange: (field: string, value: any) => void;
}

const Refraction: React.FC<RefractionProps> = ({ data, onChange }) => {
  return (
    <div className="card mb-3">
      <div className="card-body">
        <h5 className="card-title">
          <i className="fa fa-sliders me-1"></i>
          Refracción
        </h5>
        <div className="row mt-3">
          <div className="col-md-3">
            <div className="mb-3">
              <label className="form-label">Esfera OD</label>
              <input
                type="text"
                className="form-control"
                value={data.sphere_od}
                onChange={e => onChange('sphere_od', e.target.value)}
                placeholder="Ej: -3.00, +1.50"
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-3">
              <label className="form-label">Esfera OI</label>
              <input
                type="text"
                className="form-control"
                value={data.sphere_oi}
                onChange={e => onChange('sphere_oi', e.target.value)}
                placeholder="Ej: -3.00, +1.50"
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-3">
              <label className="form-label">Cilindro OD</label>
              <input
                type="text"
                className="form-control"
                value={data.cylinder_od}
                onChange={e => onChange('cylinder_od', e.target.value)}
                placeholder="Ej: -1.00, -0.75"
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-3">
              <label className="form-label">Cilindro OI</label>
              <input
                type="text"
                className="form-control"
                value={data.cylinder_oi}
                onChange={e => onChange('cylinder_oi', e.target.value)}
                placeholder="Ej: -1.00, -0.75"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <div className="mb-3">
              <label className="form-label">Eje OD (°)</label>
              <input
                type="text"
                className="form-control"
                value={data.axis_od}
                onChange={e => onChange('axis_od', e.target.value)}
                placeholder="Ej: 180, 90"
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-3">
              <label className="form-label">Eje OI (°)</label>
              <input
                type="text"
                className="form-control"
                value={data.axis_oi}
                onChange={e => onChange('axis_oi', e.target.value)}
                placeholder="Ej: 180, 90"
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-3">
              <label className="form-label">Adición OD</label>
              <input
                type="text"
                className="form-control"
                value={data.add_od}
                onChange={e => onChange('add_od', e.target.value)}
                placeholder="Ej: +2.00"
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="mb-3">
              <label className="form-label">Adición OI</label>
              <input
                type="text"
                className="form-control"
                value={data.add_oi}
                onChange={e => onChange('add_oi', e.target.value)}
                placeholder="Ej: +2.00"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Refraction;
